new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_list',
    data: {
        menuFilter: false,
        listOpened: false,
        listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : 2
    },
    methods: {
      changeList(list) {
        this.listEx = list;
        this.listOpened = false;
        localStorage.setItem('listOrder', list);
      }
    },
    watch: {
        menuFilter(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
        listOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
      }
})